<template>
	<div class="login-container" v-if="pageType == 'login'">
		<language-switcher class="login-language-switcher"></language-switcher>
		<!-- 登录弹窗 -->
		<login-dialog :isShow="true" :isShowCloseBtn="false" @close="closeLoginDialog">
		</login-dialog>

		<!-- 网站备案 -->
		<div class="footer">
			<p class="footer-txt">
				{{copyright||"版权所有(C) 2017-现在 杭州吉客云网络技术有限公司"}}&nbsp;
				<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
					{{ICPNNumber||"浙ICP备18019426号-1"}}
				</a>
			</p>
			<p class="footer-txt" v-if="isShowCybersecuritycNumber">
				<img src="../../assets/images/icon-police.png" alt="">
				<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014798" target="_blank" rel="noopener noreferrer">
					{{cybersecuritycNumber||"浙公网安备 33011002014798 号"}}&nbsp;&nbsp;</a>
				<a data-v-b6ac6d7e="" href="https://new.cnzz.com/v1/login.php?siteid=1279031780" target="_blank" rel="noopener noreferrer"> {{ $t("home.home.336045-6") }} </a>
			</p>
		</div>
	</div>
	<div v-else>
		<checkin-apply formHeight='540px'></checkin-apply>
	</div>

</template>

<script>
	import NamePwdDialog from '../../components/common/NamePwdDialog.vue';
	import CheckInApply from '../../components/common/CheckInApply.vue';
	import LoginDialog from '../../components/common/LoginDialog.vue';
	import LanguageSwitcher from '../../components/common/LanguageSwitcher.vue';
	import { getCustomerInfo, registeCustomer } from '../../utils/api-utils/api-customer.js';
	import { getParam } from '../../utils/api-utils/api-params.js';
	import commonUtil from '../../utils/common-utlis.js';
	import { system } from '../../utils/api-utils/api-sys.js';
	import '../../theme/element/theme/self.css'
	var interval;
	export default {
		name: 'Login',
		components: {
			'name-pwd-dialog': NamePwdDialog,
			'checkin-apply': CheckInApply,
			'login-dialog': LoginDialog,
			'language-switcher': LanguageSwitcher,
		},
		data() {
			return {
				loginTel: "", // 用户输入的手机号
				loginCode: "", // 用户输入的验证码
				loginPhone: "", // 用户输入的手机号
				loginPassword: "", // 用户输入的密码
				sysLoginCode: "", // 系统发送的验证码，用作校验
				vcodeBtnTxt: this.$t("common.LoginDialog.241483-18"), // 获取验证码按钮文字
				vcodeIntervalTime: 60, // 验证码发送间隔 
				loginClicked: false, // 按钮已点击
				loginType: "pwd", // 登录方式 tel:手机号验证码, pwd:登录名密码
				loginName: "", //登录名
				loginPwd: "", //登录密码
				showCompleteInfo: false, //完善信息弹窗（用户名密码）
				forgetClicked: false, //点击了忘记密码
				oldLoginName: "", //原登录名
				restrictLoginText: this.$t("home.login.340266-1"),
				isOpenLoginLimit: false,
				pageType: 'login',
				loginLimitApplySettingList: [],
				copyright: "", // 版权
				ICPNNumber: "", // 备案号
				cybersecuritycNumber: "", //网安备案号
				isShowCybersecuritycNumber: true, // 是否显示公安备案
				customerInfo: {}
			}
		},
		created: function() {
			this.loadParam(); // 获取参数
		},
		methods: {
			/**
			 * 关闭登录弹窗（下级调用） 登录成功也会调这个
			 */
			async closeLoginDialog({ isJustClose, isNeedShowApplyForm, isLoginSuccess } = {}) {
				this.isShowLoginDialog = false;

				if (isLoginSuccess) {
					// 跳转到首页
					this.$router.push({
						name: 'home'
					})
				}

				// 展示申请表单
				if (isNeedShowApplyForm) {
					this.pageType = 'apply'
				}
			},

			/**
			 * 加载参数
			 */
			async loadParam() {
				let params = await getParam("pc_restrictLoginText,isOpenLoginLimit,loginLimitType,domainFiling");
				if (!!params.pc_restrictLoginText) {
					this.restrictLoginText = params.pc_restrictLoginText.replaceAll('\n', '<br>');
				}

				// 自定义备案信息
				var domainFiling = params.domainFiling;
				if (domainFiling) {
					try {
						var domainFilingList = domainFiling.split(',');
						this.copyright = (domainFilingList[0] || "").trim().replace("2017-2020", "2017-现在");
						this.ICPNNumber = (domainFilingList[1] || "").trim();
						this.cybersecuritycNumber = (domainFilingList[2] || "").trim();
						this.isShowCybersecuritycNumber = !!this.cybersecuritycNumber;
					} catch (e) {}
				}

				this.isOpenLoginLimit = params.isOpenLoginLimit == '1';
				this.loginLimitType = params.loginLimitType;
			},
		}
	}
</script>

<style scoped="scoped">
	.login-box {
		padding: 30px 50px;
		width: 400px;
		margin: 50px auto 0;
	}

	.login-language-switcher {
		position: fixed;
		top: 26px;
		right: 28px;
		z-index: 10;
	}


	.login-tips {
		text-align: center;
		color: #999;
		font-size: 16px;
	}

	.login-title {
		text-align: center;
		font-size: 26px;
		margin-top: 30px;
		margin-bottom: 50px;
	}

	.login-item {
		margin-bottom: 20px;
	}

	.input-vcode {
		width: 278px;
	}

	.btn-vcode {
		margin-left: 10px;
		width: 112px;
	}

	.btn-login {
		width: 100%;
	}

	.btn-change-type {
		border: 1px solid #f56c6c;
		color: #f56c6c;
	}

	.footer {
		position: fixed;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.footer-txt {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		color: #333;
		font-size: 13px;
	}
</style>